import * as DisclosureType from './constants/disclosureType';

class RoutingConfiguration{

    static dataForController($q, loggerService, promiseList, outputMap, errMsg) 
    {
        let deferred = $q.defer();
        return $q.all(promiseList).then((data) => {
            let hasError = false;
            for (let dataValue of data) {
                if (dataValue.error) {
                    hasError = true;
                }
            }
            if (hasError) {
                loggerService.logError("Error loading page", errMsg, this, true);
                deferred.reject();
            } else {
                deferred.resolve(outputMap(data));
            }            
            return deferred.promise;
        });
    }

    static redirectToReviewIfWrongStateForAssessment(preFetchedData, securityService, $state) {
        let curtinId = securityService.getAutheticatedUserId();
        if (this.denyAssessment(preFetchedData, curtinId)) {
            
            if (preFetchedData.disclosureData.type === DisclosureType.CONFLICT) {
                $state.go("/.coi.conflictofinterestreview", { disclosureId: preFetchedData.disclosureData.id });
            }

            if (preFetchedData.disclosureData.type === DisclosureType.GIFT) {
                $state.go("/.coi.giftreview", { disclosureId: preFetchedData.disclosureData.id });
            }
        }
    }

    static denyAssessment(preFetchedData, curtinId) {
        return preFetchedData.disclosureData.status !== 'PendingAssessment' ||
            this.denyAssessmentWhenNotLineManager(preFetchedData, curtinId) ||
            this.denyAssessmentWhenNotAlternateOfficer(preFetchedData, curtinId);
    }

    static denyAssessmentWhenNotLineManager(preFetchedData, curtinId) {
        return preFetchedData.disclosureData.lineManagerId && preFetchedData.disclosureData.lineManagerId !== curtinId &&
            !preFetchedData.disclosureData.alternativeOfficerId;
    }

    static denyAssessmentWhenNotAlternateOfficer(preFetchedData, curtinId) {
        return preFetchedData.disclosureData.alternativeOfficerId && preFetchedData.disclosureData.alternativeOfficerId !== curtinId;
    }

    static config(stateProvider, locationProvider, urlRouterProvider) {

        locationProvider.html5Mode(true);

        stateProvider
            .state("auth", {
                url: "/auth",
                abstrct: true,
                templateUrl: "/app/layout/shell.without.menu.html"
            })
                .state("auth.login", {
                    url: "/login",
                    templateUrl: "app/login/login.html"
                })
            .state("auth.sso", {
                url: "/sso",
                templateUrl: "app/sso/sso.html"
            })
            .state("/", {
                url: "/",
                abstrct: true,
                templateUrl: "/app/layout/shell.with.top.menu.html"
            })
                  .state("/.coi", {
                      url: "coi",
                      abstrct: true,
                      templateUrl: "/app/layout/shell.with.left.menu.html"
                  })
                        .state("/.coi.home", {
                            url: "/home",
                            templateUrl: "app/home/home.html"
                        })
                        .state("/.coi.disclose", {
                            url: "/disclose",
                            templateUrl: "app/disclose/disclose.html"
                        })
                        .state("/.coi.conflictofinterest", {
                            url: "/disclose/conflictofinterest/:disclosureId",
                            templateUrl: "app/disclose/conflictofinterest/conflictofinterest.html",
                            vparent: "/.coi.disclose",
                            resolve: {
                                preFetchedData: ['helperService', 'userService', '$q', 'loggerService', 'disclosureService', '$stateParams', 
                                    (helperService, userService, $q, loggerService, disclosureService, $stateParams) => {

                                    let promiseList = [
                                        helperService.getConflictCategories.bind(helperService)(),
                                        userService.getLineManagers.bind(userService)(),
                                        userService.getPrimaryLineManager.bind(userService)(),
                                        helperService.getEmploymentOptions.bind(helperService)()
                                    ];

                                    if ($stateParams.disclosureId) {
                                        promiseList.push(disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId));
                                        promiseList.push(disclosureService.getAlternativeOfficer.bind(disclosureService)($stateParams.disclosureId));
                                    }

                                    let errMsg = "error loading conflict of interest page";

                                    let outputMap = (data) => ({
                                        conflictCategories: data[0].data,
                                        lineManagers: data[1].data,
                                        primaryLineManager: data[2].data,
                                        employmentOptions: data[3].data,
                                        disclosureData: data.length > 4 ? data[4].data : null,
                                        alternativeOfficer: data.length > 5 ? data[5].data : null
                                    });

                                    return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);
                                }]

                            },
                            onEnter:['$state', 'preFetchedData', function($state, preFetchedData) {
                                if (preFetchedData.disclosureData && preFetchedData.disclosureData.status !== 'Draft' && preFetchedData.disclosureData.status !== 'Amending') {
                                    $state.go("/.coi.conflictofinterestreview", {disclosureId: preFetchedData.disclosureData.id});
                                }
                            }],
                            controller: 'conflictOfInterestController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.conflictofinterestreview", {
                             url: "/disclose/conflictofinterest/review/:disclosureId",
                             templateUrl: "app/disclose/conflictofinterest/review.html",
                             vparent: "/.coi.disclose",
                             resolve: {
                                preFetchedData: [
                                    'helperService', 'userService', '$q', 'loggerService', 'disclosureService', '$stateParams',
                                    (helperService, userService, $q, loggerService, disclosureService, $stateParams) => {

                                        let promiseList = [
                                            helperService.getConflictCategories.bind(helperService)(),
                                            helperService.getEmploymentOptions.bind(helperService)(),
                                            disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId),
                                            helperService.getManagementStrategies.bind(helperService)()
                                        ];
                                        
                                        let errMsg = "error loading conflict of interest review page";

                                        let outputMap = (data) => ({
                                            conflictCategories: data[0].data,
                                            lineManager: data[2].data.discloserLineManager,
                                            employmentOptions: data[1].data,
                                            disclosureData: data[2].data,
                                            alternativeOfficer: data[2].data.discloserAlternateOfficer,
                                            managementStrategies: data[3].data
                                        });

                                        return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                    }]
                                },
                                controller: 'reviewController',
                                controllerAs: 'vm'
                        })
                        .state("/.coi.disclosuresuccess", {
                            url:"/disclose/success/:disclosureId",
                            templateUrl: "app/disclose/success.html",
                            vparent: "/.coi.disclose",
                            resolve: {preFetchedData: [
                                '$q', 'disclosureService', '$stateParams', 'loggerService',
                                ($q, disclosureService, $stateParams, loggerService) => {

                                    let promiseList = [
                                        disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId)
                                    ];

                                    let errMsg = "error loading conflict of interest review page";

                                    let outputMap = (data) => ({
                                        disclosureData: data[0].data
                                    });

                                    return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);
                                    
                                }
                            ]},
                            controller: 'successController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.gift", {
                            url: "/disclose/gift/:disclosureId",
                            templateUrl: "app/disclose/gift/gift.html",
                            vparent: "/.coi.disclose",
                            resolve: {
                                preFetchedData: ['userService', '$q', 'loggerService', 'disclosureService', '$stateParams',
                                    (userService, $q, loggerService, disclosureService, $stateParams) => {

                                        let promiseList = [                                
                                            userService.getPrimaryLineManager.bind(userService)(),
                                            userService.getExecutiveManagers.bind(userService)()                                   
                                        ];

                                        if ($stateParams.disclosureId) {
                                            promiseList.push(disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId));
                                        }

                                        let errMsg = "error loading gift page";

                                        let outputMap = (data) => ({
                                            lineManager: data[0].data[0],
                                            executiveManagers: data[1].data,
                                            disclosureData: data.length > 2 ? data[2].data : null
                                        });

                                        return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                    }]

                            },
                            onEnter:['$state', 'preFetchedData', function($state, preFetchedData) {
                                if (preFetchedData.disclosureData && preFetchedData.disclosureData.status !== 'Draft'  && preFetchedData.disclosureData.status !== 'Amending') {
                                    $state.go("/.coi.giftreview", {disclosureId: preFetchedData.disclosureData.id});
                                }
                            }],
                            controller: 'giftController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.giftreview", {
                            url: "/disclose/gift/review/:disclosureId",
                            templateUrl: "app/disclose/gift/giftreview.html",
                            vparent: "/.coi.disclose",
                            resolve: {
                                    preFetchedData: ['userService', '$q', 'loggerService', 'disclosureService', 'helperService', '$stateParams',
                                    (userService, $q, loggerService, disclosureService, helperService, $stateParams) => {

                                        let promiseList = [
                                            disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId),    
                                            helperService.getManagementStrategies.bind(helperService)()
                                        ];

                                        let errMsg = "error loading gift page";

                                        let outputMap = (data) => ({
                                            lineManager: data[0].data.discloserLineManager,
                                            disclosureData: data[0].data,
                                            alternativeOfficer: data[0].data.discloserAlternateOfficer,
                                            managementStrategies: data[1].data
                                        });

                                        return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                    }]

                            },
                            controller: 'giftReviewController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.mydisclosures", {
                            url: "/mydisclosures",
                            templateUrl: "app/disclose/mydisclosures.html",
                            resolve: {preFetchedData: [
                                '$q', 'disclosureService', '$stateParams', 'loggerService', 'helperService',
                                ($q, disclosureService, $stateParams, loggerService, helperService) => {

                                    let promiseList = [
                                        disclosureService.getPagedDisclosures.bind(disclosureService)({ pageSize: 20, pageIndex: 1, sortDirection: 'Descending'}),
                                        helperService.getDisclosureStatusFilters.bind(helperService)()
                                    ];
                                    
                                    let errMsg = "error loading my disclosures page";

                                    let outputMap = (data) => ({
                                        disclosureList: data[0].data,
                                        disclosureStatusOptions: data[1].data
                                    });

                                    return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                }
                            ]},
                            controller: 'myDisclosuresController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.mytasks", {
                            url: "/mytasks",
                            templateUrl: "app/assess/mytasks.html",
                            resolve: {preFetchedData: [
                                '$q', 'userService', 'loggerService', 'helperService',
                                ($q, userService, loggerService, helperService) => {

                                    let promiseList = [
                                        userService.getMyTasks.bind(userService)({ pageSize: 20, pageIndex: 1, sortDirection: 'Descending' }),
                                        helperService.getDisclosureStatusFilters.bind(helperService)()
                                    ];
                                    
                                    let errMsg = "error loading line manager tasks page";

                                    let outputMap = (data) => ({
                                        taskList: data[0].data,
                                        disclosureStatusOptions: data[1].data
                                    });

                                    return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                }
                            ]},
                            controller: 'myTasksController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.conflictassess", {
                            url: "/conflict/assess/:disclosureId",
                            vparent: "/.coi.mytasks",
                            templateUrl: "/app/assess/conflictOfInterest/conflictOfInterestAssessment.html",
                            resolve:{
                                preFetchedData: ['$stateParams', '$q','disclosureService', 'loggerService', 'helperService', 'userService',
                                    ($stateParams, $q, disclosureService, loggerService, helperService, userService) => {      
                                        
                                        let promiseList = [
                                            helperService.getConflictCategories.bind(helperService)(),
                                            helperService.getEmploymentOptions.bind(helperService)(),
                                            helperService.getManagementStrategies.bind(helperService)()
                                        ];

                                        if ($stateParams.disclosureId) {
                                            promiseList.push(disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId));
                                        }

                                        let errMsg = "error loading assess page";

                                        let outputMap = (data) => ({
                                            conflictCategories: data[0].data,
                                            employmentOptions: data[1].data,
                                            managementStrategies: data[2].data,
                                            disclosureData: data.length > 3 ? data[3].data : null,
                                            lineManager: data[3].data.discloserLineManager,
                                            alternativeOfficer: data[3].data.discloserAlternateOfficer
                                        });

                                        return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                    }]
                            },
                            onEnter:['$state', 'preFetchedData', 'securityService', function($state, preFetchedData, securityService) {
                                RoutingConfiguration.redirectToReviewIfWrongStateForAssessment(preFetchedData, securityService, $state);
                            }],
                            controller: 'conflictOfInterestAssessmentController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.gifttassess", {
                            url: "/gift/assess/:disclosureId",
                            vparent: "/.coi.mytasks",
                            templateUrl: "/app/assess/gift/gift-assessment.html",
                            resolve:{
                                preFetchedData: ['$stateParams', '$q','disclosureService', 'loggerService', 'helperService', 'userService',
                                    ($stateParams, $q, disclosureService, loggerService, helperService, userService) => {          
                                        
                                        let promiseList = [          
                                            disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId),
                                            helperService.getManagementStrategies.bind(helperService)()
                                        ]; 

                                        let errMsg = "error loading assess page";

                                        let outputMap = (data) => ({
                                            lineManager: data[0].data.discloserLineManager,
                                            disclosureData: data[0].data,
                                            alternativeOfficer: data[0].data.discloserAlternateOfficer,
                                            managementStrategies: data[1].data
                                        });
                                        
                                        return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                                    }]
                            },
                            onEnter:['$state', 'preFetchedData', 'securityService', function($state, preFetchedData, securityService) {
                                RoutingConfiguration.redirectToReviewIfWrongStateForAssessment(preFetchedData, securityService, $state);
                            }],
                            controller: 'giftAssessmentController',
                            controllerAs: 'vm'
                        })
                        .state("/.coi.assessmentsuccess", {
                            url:"/assess/success/:disclosureType/:disclosureId/:displayId",
                            templateUrl: "app/assess/assessment-success.html",
                            vparent: "/.coi.mytasks",
                            resolve: {preFetchedData: [
                                '$q', 'disclosureService', '$stateParams',
                                ($q, disclosureService, $stateParams) => {
                                    return { disclosureData: { disclosureId: $stateParams.disclosureId, disclosureType: $stateParams.disclosureType, displayId: $stateParams.displayId } };
                                }
                            ]},
                            controller: 'assessmentSuccessController',
                            controllerAs: 'vm'
                        })
                        .state("/.admin", {
                            url: "admin",
                                    abstrct: true,
                                    templateUrl: "/app/layout/shell.with.left.menu.html"
                                })
                            .state("/.admin.home", {
                                    url: "/home",
                                templateUrl: "app/admin/admin.html"
                            })
                  .state("/.admin.managedisclosures", {
                      url: "/managedisclosures?maxSize",
                      templateUrl: "app/admin/manage-disclosures.html",
                      resolve: {preFetchedData: [
                          '$stateParams', '$q', 'adminService', 'loggerService','helperService',
                          ($stateParams, $q, adminService, loggerService,helperService) => {
                              let maxSize = 50;

                              if ($stateParams.maxSize) {
                                  let value =  $stateParams.maxSize.match(/\d*/)[0];    
                                  if(!_.isEmpty(value)) {
                                      maxSize = value;
                                  }
                              }

                              let promiseList = [
                                  adminService.getManageDisclosures.bind(adminService)({ 
                                      pageIndex: 1, 
                                      pageSize: maxSize, 
                                      displayId: "", 
                                      statusList: "AssessedPendingIsu,PendingRoAssignment", 
                                      disclosureType: "" 
                                  }),
                                  helperService.getDisclosureSearchFilters.bind(helperService)(),
                                  helperService.getDisclosureStatusFiltersForAdminSearch.bind(helperService)(),
                                  helperService.getDisclosureTypeOptions.bind(helperService)(),
                                  helperService.getDistinctFaculties.bind(helperService)(),
                                  helperService.getDistinctSchools.bind(helperService)()
                              ];
                                    
                              let errMsg = "error loading manage disclosures page";

                              let outputMap = (data) => ({
                                  disclosureList: data[0].data,
                                  disclosureSearchFilters: data[1].data,
                                  disclosureStatusOptions: data[2].data,
                                  disclosureTypeOptions: data[3].data,
                                  facultyOptions: data[4].data,
                                  schoolOptions: data[5].data
                              });

                              return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);

                          }
                      ]},
                      controller: 'manageDisclosuresController',
                      controllerAs: 'vm'
                  })
                .state("/.admin.reviewconflictdisclosure", {
                    url: "/conflictofinterest/review/:disclosureId",
                    templateUrl: "app/disclose/conflictofinterest/review.html",
                    vparent: "/.admin.managedisclosures",
                    resolve: {
                        preFetchedData: [
                            'helperService', 'userService', '$q', 'loggerService', 'disclosureService', '$stateParams',
                            (helperService, userService, $q, loggerService, disclosureService, $stateParams) => {

                                let promiseList = [
                                   helperService.getConflictCategories.bind(helperService)(),
                                   helperService.getEmploymentOptions.bind(helperService)(),
                                   helperService.getManagementStrategies.bind(helperService)(),
                                   disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId)
                                ];
                                        
                                let errMsg = "error loading conflict of interest review page";

                                let outputMap = (data) => ({
                                    conflictCategories: data[0].data,
                                    employmentOptions: data[1].data,
                                    managementStrategies: data[2].data,
                                    disclosureData: data[3].data,
                                    lineManager: data[3].data.discloserLineManager,
                                    alternativeOfficer: data[3].data.discloserAlternateOfficer
                                });

                                return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);
                                    
                            }]
                    },
                    controller: 'reviewController',
                    controllerAs: 'vm'
                })
                .state("/.admin.reviewgiftdisclosure", {
                    url: "/gift/review/:disclosureId",
                    templateUrl: "app/disclose/gift/giftreview.html",
                    vparent: "/.admin.managedisclosures",
                    resolve: {
                        preFetchedData: ['userService', '$q', 'loggerService', 'disclosureService', 'helperService', '$stateParams',
                        (userService, $q, loggerService, disclosureService, helperService, $stateParams) => {

                        let promiseList = [
                            userService.getExecutiveManagers.bind(userService)(),  
                            helperService.getManagementStrategies.bind(helperService)(),
                            disclosureService.getDisclosure.bind(disclosureService)($stateParams.disclosureId)            
                        ];

                        let errMsg = "error loading gift page";

                        let outputMap = (data) => ({
                            executiveManagers: data[0].data,
                            managementStrategies: data[1].data,
                            disclosureData: data[2].data,
                            lineManager: data[2].data.discloserLineManager,
                            alternativeOfficer: data[2].data.discloserAlternateOfficer
                        });

                        return RoutingConfiguration.dataForController($q, loggerService, promiseList, outputMap, errMsg);
                                    
                        }]
                    },
                    controller: 'giftReviewController',
                    controllerAs: 'vm'
                })
                .state("error", {
                    url: "/error",
                    abstrct: true,
                    templateUrl: "/app/layout/shell.without.menu.html"
                })
                .state("error.404", {
                    url: "/404",
                    templateUrl: "/app/error/404.html"
                })
                .state("error.403", {
                    url: "/403",
                    templateUrl: "/app/error/403.html"
                });

        urlRouterProvider.otherwise("/error/404");
    }
}

RoutingConfiguration.config.$inject = ['$stateProvider', '$locationProvider', '$urlRouterProvider'];

export default RoutingConfiguration;


// WEBPACK FOOTER //
// ./app/routing.configuration.js